<template>
  <!-- 修改历史查询 -->
  <div class="page-container" id="ebOrderContainer">
    <el-form :model="ebOrder" ref="ruleFormRef" class="form-panel" label-position="top"
             :validateOnRuleChange="false">
      <el-col :span="24">
        <!-- <div> -->
        <el-row class="content-panel top-radius">
          <el-col style="height:12px;">
          </el-col>
          <el-col>
            <el-row :gutter="24">
              <el-col :span="5">
                <el-row>
                  <el-col :span="16">
                    <el-form-item label="大船船名/航次:">
                      <el-associate
                        style="width: 100%"
                        :columns="associate_columns_vessel"
                        :query-method="associate_queryMethod_vessel"
                        class="input_length"
                        clearable
                        :query-length="0"
                        :default-first-option="true"
                        label-prop="vesselName"
                        value-prop="mdVoyagePlanId"
                        placeholder=""
                        v-model="searchData.vesselName"
                        size="mini"
                        name="vesselName"
                        @change="onChangeVessel"
                        case="upper"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item>
                      <label slot="label" class="label_no"></label>
                      <el-input size="mini" placeholder="" clearable v-model="voyage1" case="upper"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="5">
                <el-form-item label="装货港:">
                  <el-associate
                    style="width: 100%"
                    :columns="associate_columns_po"
                    :query-method="associate_queryMethod_po"
                    class="input_length"
                    clearable
                    :query-length="0"
                    :default-first-option="true"
                    label-prop="portNameEn"
                    value-prop="mdPortId"
                    placeholder=""
                    v-model="searchData.polName"
                    @change="onPolChange"
                    size="mini"
                    name="polName"
                    case="upper"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="客户业务编号:">
                  <el-input size="mini" v-model="custBizNo1"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="提单号:">
                  <el-input size="mini" v-model="mblNo1"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item label="业务环节:">
                  <el-select size="mini" clearable v-model="searchData.dataType" placeholder="请选择">
                    <el-option
                      v-for="item in dataTypeList"
                      :key="item.key"
                      :label="item.value"
                      :value="item.key"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col>
            <el-row :gutter="24">
              <el-col :span="5">
                <el-row>
                  <el-form-item label="开航时间从/开航时间到:"></el-form-item>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item>
                      <el-date-picker
                        v-model="searchData.etdFrom"
                        align="right"
                        type="date"
                        style="width:100%;"
                        size="mini"
                        placeholder=""
                        :picker-options="pickerOptions">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item >
                      <el-date-picker
                        v-model="searchData.etdTo"
                        align="right"
                        type="date"
                        default-time="23:59:59"
                        style="width:100%;"
                        size="mini"
                        placeholder=""
                        :picker-options="pickerOptions"
                        @change="changeEndEtd">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="5">
                <el-row>
                  <el-form-item label="操作时间从/操作时间到:"></el-form-item>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item >
                      <el-date-picker
                        v-model="searchData.editFrom"
                        align="right"
                        type="date"
                        style="width:100%;"
                        size="mini"
                        placeholder=""
                        :picker-options="pickerOptions">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item >
                      <el-date-picker
                        v-model="searchData.editTo"
                        align="right"
                        type="date"
                        default-time="23:59:59"
                        style="width:100%;" size="mini"
                        placeholder=""
                        :picker-options="pickerOptions"
                        @change="changeEndEditTo"
                      >
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="5">
                <el-form-item label="待处理状态:">
                  <el-select size="mini" clearable v-model="searchData.status" placeholder="请选择">
                    <el-option
                      v-for="item in statusList"
                      :key="item.key"
                      :label="item.value"
                      :value="item.key"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-row style="float:right">
                  <el-form-item label=" ">
                    <el-button type="primary" class="el-button-search" size="small" plain @click="queryOrderTransferStatus" >查询</el-button>
                    <el-button type="primary" size="small" plain @click="resetForm" >重置</el-button>
                  </el-form-item>

                </el-row>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <!-- </div> -->
 <el-row class="table-panel">
        <!-- 表格-start -->
        <el-row>
          <hot-table
            ref="ebOrderTableRef"
            :data-source="ebOrderTableDataSource"
            :settings="ebOrderTableSettings"
            col-settings-key="eiOrder"
            @cellDblclick="clickBill"
            @dblclick="dbClickBill"
          >
            <hot-column :has-tip="true" data="ebOrderId" title="操作" width="120" hidden="true">
              <column-printing-renderer hot-renderer @clickModule="clickModule"></column-printing-renderer>
            </hot-column>
            <hot-column :has-tip="true" data="orderNo" title="订单号" width="150"></hot-column>
            <hot-column :has-tip="true" data="custBizNo" title="客户业务编号" width="150"></hot-column>
            <hot-column :has-tip="true" data="vesselNameEn" title="大船船名" width="150"></hot-column>
            <hot-column :has-tip="true" data="voyage" title="大船航次" width="150"></hot-column>
            <hot-column :has-tip="true" data="etd" title="开航日期" width="150" date-format="YYYY-MM-DD"></hot-column>
            <hot-column :has-tip="true" data="mblNo" title="提单号" width="150"></hot-column>
            <hot-column :has-tip="true" data="polName" title="装货港" width="150"></hot-column>
            <hot-column :has-tip="true" data="podName" title="卸货港" width="150"></hot-column>
            <hot-column :has-tip="true" data="dataType" title="订单环节" width="150"></hot-column>
            <hot-column :has-tip="true" data="orderType" title="委托状态" width="150"  dictName="EI_ORDER_TYPE"></hot-column>
            <hot-column :has-tip="true" data="createTime" title="用户操作时间" width="150" date-format="YYYY-MM-DD HH:mm:ss"></hot-column>
            <hot-column :has-tip="true" data="status" title="待处理状态" width="150" dictName="COM_STATUS"></hot-column>
          </hot-table>

        </el-row>
      <!-- 分页start -->
      <div class="pg_div">
        <el-pagination
          :current-page="pageConfig.currentPage"
          :layout="pageConfig.layout"
          :page-size="pageConfig.pageSize"
          :page-sizes="pageConfig.pageSizes"
          :total="pageConfig.total"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </div>
 </el-row>
       </el-col>
      <!-- 分页end -->
      <!-- 表格-end -->
    </el-form>
  </div>
</template>

<script>
import {
  queryCarrierInfo,
  queryDictRows,
  queryPoInfo,
  queryVesselInfo, queryVoyageInfo
} from "@/api/commonService";
import ebOrder from "@/api/ebOrder";

export default {
  name: "HistoryEdit",
  data() {
    return {
      historyEditForm: {
        mblNo: null,
        carrierName: null,
        custBizNo: null,
      },
      mblNo1: null,
      custBizNo1: null,
      voyage1: null,
      dataTypeList: [], //订舱环节
      statusList: [], //订舱环节
      //日期设置
      pickerOptions: {
       /* disabledDate(time) {
          return time.getTime() > Date.now();
        },*/
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            }
          },
          {
            text: '昨天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', date);
            }
          },
          {
          text: '一周前',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            }
          }
        ]
      },
      // 船公司联想控件
      associate_columns_carrier: [
        {
        title: "中文简称",
        field: 'custAlias'
        },
        {
          title: "中文全称",
          field: 'custNameCn'
        },
        {
          title: "助记码",
          field: 'mnemonicCode'
        }
      ],
      // 船名联想控件
      associate_columns_vessel: [
        {
          title: "船名",
          field: "vesselName",
        },
        {
          title: "航次",
          field: "voyage",
        },
      ],
      // 航次联想控件
      associate_columns_voyage: [{
        title: "航次",
        field: 'voyage'
      }],
      // 装/卸货港联想控件
      associate_columns_po: [
        {
          title: "英文名称",
          field: "portNameEn",
        },
        {
          title: "中文名称",
          field: "portNameCn",
        },
        {
          title: "国家代码",
          field: "countryCode",
        },
        {
          title: "海港代码",
          field: "portCode",
        },
      ],
      ebOrder: {
        orderNo: '',
        mblNo: '',
        hblNo: '',
        containerNo: '',
        transportType: '',
        shipper: '',
        consignee: '',
        pol: '',
        pod: '',
        OrderType: '',
      },
      mainOrder: {
        atdFrom: '',
        atdTo: '',
        ataFrom: '',
        ataTo: '',
        projectNo: '',
      },
      //查询数据
      searchData: {
        vesselName: null,
        voyage: null,
        polName: null,
        custBizNo: null,
        mblNo: null,
        billNo: null,
        dataType: null,
        etdFrom: null,
        etdTo: null,
        editFrom: null,
        editTo: null,
      },
      // 分页
      pageConfig: {
        layout: "total, sizes, prev, pager, next, jumper",
        total: 0,
        pageSize: 100,
        pagerCount: 100,
        currentPage: 1,
        pageSizes: [10, 20, 50, 100, 500],
      },
      //订单状态列表
      eiOrderStatusList: [],
      // 表格校验
      ebOrderRules: {},
      // 表格数据
      ebOrderTableDataSource: [
      ],
      // 表格设置
      ebOrderTableSettings: {
        height: 520,
        stretchH: 'all', // 根据宽度横向扩展，last:只扩展最后一列，none：默认不扩展
        ...this.$systemConfig.tableConfig,
      },
     pageID: {},
    };
  },
  async created() {

  },
  mounted() {
    let self = this;
    self.queryDictRows();
    self.queryStatusDictRows();
    self.queryEiOrderStatus();
    /**跳转到此界面接收值**/
    /*if (this.$route.params.arrayNo) {
      self.historyEditForm.arrayNo = this.$route.params.arrayNo;
      if (self.historyEditForm.arrayNo !== undefined) {
        self.mblNo1 = self.historyEditForm.arrayNo;
      }
    }*
    //主页跳转查询，已取消
    /*self.mblNo1 = null;
    self.custBizNo1 = null;
    if (this.$route.params) {
      self.historyEditForm.mblNo = this.$route.params.mblNo;
      self.historyEditForm.custBizNo = this.$route.params.custBizNo;
      if (self.historyEditForm.mblNo !== null ) {
        self.mblNo1 = self.historyEditForm.mblNo;
      }
      if (self.historyEditForm.custBizNo !== null){
        self.custBizNo1 = self.historyEditForm.custBizNo;
      }
      if(self.historyEditForm.mblNo !==null || self.historyEditForm.custBizNo !== null){
        self.queryOrderTransferStatus();
      }
    }*/
    // 监听外层容器div宽度的变化，做表格自适应
    this.ebOrderTableSettings.height = document.body.clientHeight - 100 -150;
    // self.resizeObserver = new ResizeObserver(entries => {
    //   self.$nextTick(() => {
    //     self.$refs.ebOrderTableRef.resizeTo(entries[0].target.clientWidth - 32)
    //   })
    // })
    // self.resizeObserver.observe(document.getElementById("ebOrderContainer"))
    // let ebOrderContainer=document.getElementById('ebOrderContainer')
		// 	let ebOrderContainerHeight=ebOrderContainer.offsetHeight
		// 	self.ebOrderTableSettings.height=ebOrderContainerHeight-185
  },
  methods: {
    //点击
    clickModule(e) {

    },
    //重置搜索框
    resetForm() {
      this.searchData = {};
      this.mblNo1 = null;
      this.custBizNo1 = null;
      this.voyage1 = null;
    },
    //查询
    queryOrderTransferStatus() {
      let self = this;
      let userInfo = JSON.parse(localStorage.getItem("userInfo"));
      //对文本框设置模糊查询
      if ( self.mblNo1 !== null && self.mblNo1 !== "" && self.mblNo1 !== undefined ){
        self.searchData.mblNo = self.mblNo1+"%";
      }
      if ( self.custBizNo1 !== null && self.custBizNo1 !== "" && self.custBizNo1 !== undefined ){
        self.searchData.custBizNo = self.custBizNo1+"%";
      }
      if ( self.voyage1 !== null && self.voyage1 !== "" && self.voyage1 !== undefined ){
        self.searchData.voyage = self.voyage1+"%";
      }
      let num = 0;
      for (let s in self.searchData) {
        if (self.searchData[s] !== null && self.searchData[s] !== "" ) {
          num++;
        }
      }
      if (num === 0) {
        self.$coreMethods.message("warning", "至少输入一个查询条件");
        return;
      } else {
        self.searchData.custId = userInfo.custId;
        self.searchData.currentPage = self.pageConfig.currentPage;
        self.searchData.pageSize = self.pageConfig.pageSize;
        ebOrder.queryReviseHistoryEbOrder(self.searchData).then((res) => {
          if (res.success) {
            self.ebOrderTableDataSource = res.records.records;
            self.count0 = self.pageConfig.total = self.ebOrderTableDataSource.length;
            self.ebOrderTableDataSource.forEach(function (ebOrder){
              if(ebOrder.dataType==='ORDER'){
                ebOrder.dataType='订单';
              }
              if(ebOrder.dataType==='FT'){
                ebOrder.dataType='舱单';
              }
            });
          }
          self.searchData.custId = null;
          self.searchData.mblNo = null;
          self.searchData.custBizNo = null;
          self.searchData.voyage = null;
          self.searchData.currentPage = null;
          self.searchData.pageSize = null;
          self.$coreMethods.message("success", "查询成功");
        });
      }
    },
    changeEndEtd() {
      let self = this;
      self.searchData.etdTo = new Date(
        self.searchData.etdTo.getTime() + 1000 * 24 * 3600 - 100
      );
    },
    changeEndEditTo() {
      let self = this;
      self.searchData.editTo = new Date(
        self.searchData.editTo.getTime() + 1000 * 24 * 3600 - 100
      );
    },

    //获取订单状态数据字典
    queryEiOrderStatus() {
      let self = this;
      queryDictRows("MD_CODE_DICT$EI_ORDER_TYPE").then((res) => {
        let dict = [];
        res.MD_CODE_DICT$EI_ORDER_TYPE.forEach((item) => {
          let param = {};
          param.name = item.value;
          param.value = item.key;
          param.count = 0;
          param.filterList = [];
          dict.push(param);
        });
        self.eiOrderStatusList = dict;
        // 数据字典
        self.$hotTableUtils.registDict({EI_ORDER_TYPE: dict});
      });
    },
    //订舱环节数据字典
    queryDictRows() {
      let self = this;
      queryDictRows("MD_CODE_DICT$EI_DATA_TYPE").then((res) => {
        self.dataTypeList = res.MD_CODE_DICT$EI_DATA_TYPE;
        let dict = [];
        res.MD_CODE_DICT$EI_DATA_TYPE.forEach((item) => {
          let param = {};
          param.name = item.value;
          param.value = item.key;
          dict.push(param);
        });
        console.log(dict)
        self.$hotTableUtils.registDict({
          'EI_DATA_TYPE': dict,
        });
      });
    },
    queryStatusDictRows() {
      let self = this;
      queryDictRows("MD_CODE_DICT$COM_STATUS").then((res) => {
        self.statusList = res.MD_CODE_DICT$COM_STATUS;
        let dict = [];
        res.MD_CODE_DICT$COM_STATUS.forEach((item) => {
          let param = {};
          param.name = item.value;
          param.value = item.key;
          dict.push(param);
        });
        console.log(dict)
        self.$hotTableUtils.registDict({
          'COM_STATUS': dict,
        });
      });
    },
    queryStatusPage() {
      let self = this;
      self.queryOrderTransferStatus();
    },
    //表格单击事件
    clickBill(val) {
      let self = this;
      let row = val.record;
      sessionStorage.setItem("ebOrderParams", JSON.stringify([row]));
      sessionStorage.setItem("ebOrderType", "edit");
      self.$router.push({
        path: '/booking/edit',
        params: {
          ebOrderId: row.ebOrderId,
          type: "edit",
        },
      });
    },
    // 表格双击事件
    dbClickBill(val) {
      let self = this;
      let row = val.record;
      if (val.col === 1) {
        sessionStorage.setItem("ebOrderParams", JSON.stringify([row]));
        sessionStorage.setItem("ebOrderType", "edit");
        self.$router.push({
          path: '/booking/edit',
          params: {
            ebOrderId: row.ebOrderId,
            type: "edit",
          },
        });
      }
    },
    // pageSize 改变时会触发
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageConfig.pageSize = val;
      let self = this;
      self.queryStatusPage(this.pageConfig.currentPage);
    },
    // currentPage 改变时会触发
    handleCurrentChange(val) {
      this.pageConfig.currentPage = val;
      let self = this;
      self.queryOrderTransferStatus();
    },
    // 装/卸货港联想控件数据源
    associate_queryMethod_po({keyword, pageSize, currentPage}) {
      let params = {};
      if (keyword === "") {
        params = {
          portType4: ["OP", "IP"],
          isDeleted5: "0",
        };
      } else {
        params = {
          portNameEn0: "%" + keyword + "%",
          portNameCn1: "%" + keyword + "%",
          countryCode2: "%" + keyword + "%",
          portCode3: "%" + keyword + "%",
          portType4: ["OP", "IP"],
          isDeleted5: "0",
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPMdPort.portNameEn"],
        mainModelName: "CTS_ILPMdPort",
        tag: "CTS_ILP_es",
        where:
          "(((((CTS_ILPMdPort.portNameEn LIKE :portNameEn0 OR CTS_ILPMdPort.portNameCn LIKE :portNameCn1) OR CTS_ILPMdPort.countryCode LIKE :countryCode2) OR CTS_ILPMdPort.portCode LIKE :portCode3) AND CTS_ILPMdPort.portType IN( :portType4)) AND CTS_ILPMdPort.isDeleted = :isDeleted5)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPMdPort.mdPortId",
          "CTS_ILPMdPort.createOffice",
          "CTS_ILPMdPort.lastModifyOffice",
          "CTS_ILPMdPort.lastModifyOfficeName",
          "CTS_ILPMdPort.lastModifierId",
          "CTS_ILPMdPort.areaCode",
          "CTS_ILPMdPort.lineNameCn",
          "CTS_ILPMdPort.portNameEn",
          "CTS_ILPMdPort.principalGroupCode",
          "CTS_ILPMdPort.customsCode",
          "CTS_ILPMdPort.isActive",
          "CTS_ILPMdPort.createOfficeName",
          "CTS_ILPMdPort.creatorName",
          "CTS_ILPMdPort.lastModifierName",
          "CTS_ILPMdPort.appCode",
          "CTS_ILPMdPort.longitude",
          "CTS_ILPMdPort.creatorId",
          "CTS_ILPMdPort.recordVersion",
          "CTS_ILPMdPort.lastModifyTime",
          "CTS_ILPMdPort.portNameCn",
          "CTS_ILPMdPort.portCode",
          "CTS_ILPMdPort.createTime",
          "CTS_ILPMdPort.isDeleted",
          "CTS_ILPMdPort.iataCode",
          "CTS_ILPMdPort.latitude",
          "CTS_ILPMdPort.lineId",
          "CTS_ILPMdPort.countryName",
          "CTS_ILPMdPort.countryCode",
          "CTS_ILPMdPort.portType",
        ],
        enableCascade: true,
      };
      return new Promise((resolve) => {
        queryPoInfo(data).then((res) => {
          console.log("res", res);
          resolve({
            records: res.data.data,
            total: parseInt(res.data.totalRecord),
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    // 船公司联想控件数据源
    associate_queryMethod_carrier({keyword, pageSize, currentPage}) {
      let params = {};
      if (keyword === "") {
        params = {
          custType4: "%SO%",
          isDeleted6: "0",
        };
      } else {
        params = {
          custAlias0: "%" + keyword + "%",
          custNameCn1: "%" + keyword + "%",
          custType4: "%SO%",
          isDeleted6: "0",
          mdmCustCode3: "%" + keyword + "%",
          mnemonicCode2: "%" + keyword + "%",
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPCsCust.custNameCn"],
        mainModelName: "CTS_ILPCsCust",
        tag: "CTS_WEB_es",
        where: "(((((CTS_ILPCsCust.custAlias LIKE :custAlias0 OR CTS_ILPCsCust.custNameCn LIKE :custNameCn1) ) AND CTS_ILPCsCust.esCustType LIKE :custType4) ) AND CTS_ILPCsCust.isDeleted = :isDeleted6)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPCsCust.csCustId",
          "CTS_ILPCsCust.custAlias",
          "CTS_ILPCsCust.custNameCn",
          "CTS_ILPCsCust.custNameEn",
          "CTS_ILPCsCust.customsRegisteredNo",
          "CTS_ILPCsCust.esCustType",
          "CTS_ILPCsCust.isActive",
          "CTS_ILPCsCust.isBlacklist",
          "CTS_ILPCsCust.isCustomer",
          "CTS_ILPCsCust.isDeleted",
          "CTS_ILPCsCust.isOneTimeCustomer",
          "CTS_ILPCsCust.isSettlement",
          "CTS_ILPCsCust.isSupplier",
          "CTS_ILPCsCust.legalPerson",
          "CTS_ILPCsCust.mdmCustCode",
          "CTS_ILPCsCust.mobileNo",
          "CTS_ILPCsCust.postCode"
        ],
        enableCascade: true
      };
      return new Promise((resolve) => {
        queryCarrierInfo(data).then((res) => {
          console.log("queryCarrierInfo", res);
          resolve({
            records: res.data.data,
            total: res.data.totalRecord,
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    // 船名联想控件数据源
    associate_queryMethod_vessel({ keyword, pageSize, currentPage }) {
      let params = {};
      if (keyword === "") {
        params = {
          isDeleted3: "0",
        };
      } else {
        params = {
          isDeleted3: "0",
          vesselName0: "%" + keyword + "%",
          voyage1: "%" + keyword + "%",
          voyageCode2: "%" + keyword + "%",
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPMdVoyagePlan.vesselName"],
        mainModelName: "CTS_ILPMdVoyagePlan",
        tag: "CTS_ILP_es",
        where:
          "(((CTS_ILPMdVoyagePlan.vesselName LIKE :vesselName0 OR CTS_ILPMdVoyagePlan.voyage LIKE :voyage1) OR CTS_ILPMdVoyagePlan.voyageCode LIKE :voyageCode2) AND CTS_ILPMdVoyagePlan.isDeleted = :isDeleted3)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPMdVoyagePlan.mdVoyagePlanId",
          "CTS_ILPMdVoyagePlan.createTime",
          "CTS_ILPMdVoyagePlan.principalGroupCode",
          "CTS_ILPMdVoyagePlan.customsVesselName",
          "CTS_ILPMdVoyagePlan.lastModifyTime",
          "CTS_ILPMdVoyagePlan.isDeleted",
          "CTS_ILPMdVoyagePlan.remark",
          "CTS_ILPMdVoyagePlan.recordVersion",
          "CTS_ILPMdVoyagePlan.voyage",
          "CTS_ILPMdVoyagePlan.voyageCode",
          "CTS_ILPMdVoyagePlan.createOffice",
          "CTS_ILPMdVoyagePlan.customsVoyage",
          "CTS_ILPMdVoyagePlan.vesselId",
          "CTS_ILPMdVoyagePlan.appCode",
          "CTS_ILPMdVoyagePlan.createOfficeName",
          "CTS_ILPMdVoyagePlan.creatorName",
          "CTS_ILPMdVoyagePlan.creatorId",
          "CTS_ILPMdVoyagePlan.customsVesselId",
          "CTS_ILPMdVoyagePlan.lastModifyOfficeName",
          "CTS_ILPMdVoyagePlan.lastModifyOffice",
          "CTS_ILPMdVoyagePlan.lastModifierName",
          "CTS_ILPMdVoyagePlan.ioFlag",
          "CTS_ILPMdVoyagePlan.carrierId",
          "CTS_ILPMdVoyagePlan.lastModifierId",
          "CTS_ILPMdVoyagePlan.vesselName",
          "CTS_ILPMdVoyagePlan.carrierName",
        ],
        enableCascade: true,
      };
      return new Promise((resolve) => {
        queryVoyageInfo(data).then((res) => {
          console.log("res", res);
          resolve({
            records: res.data.data,
            total: parseInt(res.data.totalRecord),
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    onChangeVessel(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      this.searchData.vesselName = selectedRows.vesselName;
      this.searchData.vesselId = selectedRows.vesselId;
      this.voyage1 = selectedRows.voyage;
    },
    onPolChange(value,selectedRows){
      this.searchData.polId = selectedRows.mdPortId;
      this.searchData.polName = selectedRows.portNameEn;
    },
    // 航次联想控件数据源
    associate_queryMethod_voyage({keyword, pageSize, currentPage}) {

    },
  }
};
</script>

<style scoped lang="less">

</style>
